const REFRESH_LOCK_KEY = 'acv-refresh-lock';

function callLocalStorage(action, data) {
  if (window.localStorage) {
    return window.localStorage[action](REFRESH_LOCK_KEY, data);
  }
  return null;
}

function unlockRefresh() {
  callLocalStorage('removeItem');
}

function lockRefresh(windowId = '') {
  const lockExpiration = new Date();
  lockExpiration.setSeconds(lockExpiration.getSeconds() + 10);
  const data = JSON.stringify({
    windowId,
    lockExpiration: lockExpiration.getTime(),
  });
  callLocalStorage('setItem', data);
}

function getLock() {
  const currentLockJSON = callLocalStorage('getItem');
  if (currentLockJSON) {
    const tempLock = JSON.parse(currentLockJSON);
    tempLock.lockExpiration = new Date(tempLock.lockExpiration);
    return tempLock;
  }
  return null;
}

function isLocked() {
  const currentLock = getLock();
  return currentLock !== null
    && typeof currentLock !== 'undefined';
}

function lockExpired() {
  const currentLock = getLock();
  return isLocked()
    && currentLock.lockExpiration <= new Date();
}

export {
  getLock,
  isLocked,
  lockExpired,
  unlockRefresh,
  lockRefresh,
};
